import React from 'react'

export const Link = props => (
	<a {...props}>{props.children}</a>
)
